(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CustomerGroup', CustomerGroup);

    CustomerGroup.$inject = ['$resource', 'DateUtils'];

    function CustomerGroup($resource, DateUtils) {
        var resourceUrl = 'api/customer-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
